import module from './module.js'

export default module.name



// WEBPACK FOOTER //
// ./src/kendu/index.js